module.exports = __webpack_public_path__ + "caf7072d3b91dd0d15489842ebbe2232.svg";